import * as React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image";
import { defaultFontStack } from "../../../styles/typography/v2";

const Root = styled.div((props) => ({
  display: "grid",
  height: props.height,
}));

const InnerContent = styled.div({
  display: "flex",
  flexDirection: "column",
  padding: 40,
});

const HeadText = styled.h1(defaultFontStack, (props) => ({
  fontSize: 30,
  fontWeight: 900,
  color: props.theme.colors.day,
  letterSpacing: "1.6px",
  textTransform: "uppercase",
}));

const Content = styled.div((props) => ({
  display: "flex",
  flexDirection: "column",
  "@media(min-width: 800px)": {
    flexDirection: "row",
  },
  gridArea: "1/1",
  position: "relative",
  zIndex: 1,
  overflow: "hidden",
  justifyContent: props.center ? "center" : null,
}));

function Hero(props) {
  const { head, body, image, version, center, height } = props;
  return (
    <Root data-component-name="hero" height={height}>
      {version === 2 ? (
        <StaticImage
          quality={100}
          src="./background-2.png"
          alt="background"
          objectFit="cover"
          style={{ gridArea: "1/1" }}
        />
      ) : (
        <StaticImage
          quality={100}
          src="./background.png"
          alt="background"
          objectFit="cover"
          style={{ gridArea: "1/1" }}
        />
      )}
      <Content center={center}>
        <InnerContent>
          <HeadText data-component-name="page-title">{head}</HeadText>
          {body}
        </InnerContent>
        {image}
      </Content>
    </Root>
  );
}

Hero.propTypes = {
  height: PropTypes.string,
  center: PropTypes.bool,
  head: PropTypes.node,
  body: PropTypes.node,
  image: PropTypes.node,
  version: PropTypes.number,
};

export default Hero;
